'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const PING_MS = 30_000;

/**
 * Pings /api/presence while the tab is visible so the admin dashboard can
 * count live visitors on this page subtree. Mounted in app/products/layout.tsx.
 */
export default function PresenceBeacon() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    const ping = () => {
      if (document.hidden) return;
      fetch('/api/presence', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ path: pathname }),
        keepalive: true,
      }).catch(() => {});
    };

    ping();
    const id = setInterval(ping, PING_MS);
    document.addEventListener('visibilitychange', ping);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [pathname]);

  return null;
}
